import { render, staticRenderFns } from "./CoverImageUpload.vue?vue&type=template&id=2599c1c0&scoped=true"
import script from "./CoverImageUpload.vue?vue&type=script&lang=js"
export * from "./CoverImageUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2599c1c0",
  null
  
)

export default component.exports